"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.OptionsConsumer = exports.OptionsProvider = exports.OptionsContext = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));
/* eslint-disable import/no-extraneous-dependencies */


var OptionsContext = _react.default.createContext('Options');

exports.OptionsContext = OptionsContext;

var OptionsProvider = function OptionsProvider(_ref) {
  var children = _ref.children,
      _ref$useClassNames = _ref.useClassNames,
      useClassNames = _ref$useClassNames === void 0 ? false : _ref$useClassNames,
      _ref$useAutoGen = _ref.useAutoGen,
      useAutoGen = _ref$useAutoGen === void 0 ? false : _ref$useAutoGen,
      _ref$usePathPrefix = _ref.usePathPrefix,
      usePathPrefix = _ref$usePathPrefix === void 0 ? null : _ref$usePathPrefix;
  var options = {
    useClassNames: useClassNames,
    useAutoGen: useAutoGen,
    usePathPrefix: usePathPrefix
  };
  return _react.default.createElement(OptionsContext.Provider, {
    value: options
  }, children);
};

exports.OptionsProvider = OptionsProvider;
var OptionsConsumer = OptionsContext.Consumer;
exports.OptionsConsumer = OptionsConsumer;
OptionsProvider.defaultProps = {
  useClassNames: false,
  useAutoGen: false,
  usePathPrefix: null
};
OptionsProvider.propTypes = {
  children: _propTypes.default.node.isRequired,
  useClassNames: _propTypes.default.bool,
  useAutoGen: _propTypes.default.bool,
  usePathPrefix: _propTypes.default.string
};